<!--<ng-progress-->
<!--  *browser-->
<!--  [spinner]="false"-->
<!--  color="#FF5B62"-->
<!--  id="progress"-->
<!--  class="fixed top-0 left-0 w-full z-50"-->
<!--&gt;</ng-progress>-->

@if (showHeaderAndFooter$ | async) {
  <app-header class="sticky top-0 z-[1050]"></app-header>
}

<!--@if (showHeaderAndFooter$ | async) {-->
<!--  <app-category-banner-->
<!--    [categories]="categories$ | async"-->
<!--    class="w-full hidden md:block sticky top-12 left-0 z-50"-->
<!--  ></app-category-banner>-->
<!--}-->

<div class="flex flex-col md:mb-9" [ngClass]="{ mobile: platformService.isMobile() }">
  <main #main>
    <router-outlet></router-outlet>
  </main>
</div>

<!--@if (showHeaderAndFooter$ | async) {-->
<!--  <app-footer class="mt-auto"></app-footer>-->
<!--}-->

<iframe id="iframe-auth-success" class="hidden"></iframe>

<!--<app-cookie-popup class="fixed bottom-0 left-0 right-0 z-50"></app-cookie-popup>-->

<app-json-ld [json]="structuredData"></app-json-ld>
